import { Chip } from '@/components/ui'
import type { StageHistoryEntry, Stage } from '../api/types'
import { STAGE_LABELS, STAGE_VARIANT } from '../utils/stage-meta'

function formatTimestamp(iso: string): string {
  try {
    const d = new Date(iso)
    if (Number.isNaN(d.getTime())) return iso
    return `${d.toLocaleDateString()} ${d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`
  } catch {
    return iso
  }
}

export function StageHistoryTimeline({ entries }: { entries: StageHistoryEntry[] }) {
  if (!entries || entries.length === 0) {
    return (
      <p className="m-0 text-sm text-tertiary">No history recorded yet.</p>
    )
  }

  const display = [...entries].reverse()

  return (
    <ol className="flex flex-col gap-2">
      {display.map((entry, i) => {
        const stage = entry.stage
        const label = stage ? (STAGE_LABELS[stage as Stage] ?? stage) : '—'
        const variant = stage ? (STAGE_VARIANT[stage as Stage] ?? 'neutral') : 'neutral'
        return (
          <li
            key={`${entry.at}-${stage ?? 'unknown'}-${i}`}
            className="flex items-start gap-3 border-l border-border-subtle pl-3"
          >
            <Chip size="xs" variant={variant} dot>
              {label}
            </Chip>
            <div className="min-w-0 flex-1">
              <div className="text-role-metadata">
                {formatTimestamp(entry.at)}
                {entry.actor ? ` · ${entry.actor}` : null}
              </div>
              {entry.note ? (
                <div className="mt-0.5 text-xs text-secondary">{entry.note}</div>
              ) : null}
            </div>
          </li>
        )
      })}
    </ol>
  )
}
